
import React from "react";

const TermsOfService = () => {
  const lastUpdated = "August 16, 2026";

  return (
    <div className="terms-page">
      <style>{`
        .terms-page {
          min-height: 100vh;
          background:
            radial-gradient(
              circle at top right,
              rgba(50, 191, 255, 0.10),
              transparent 35%
            ),
            radial-gradient(
              circle at top left,
              rgba(120, 70, 255, 0.08),
              transparent 30%
            ),
            #0b0f14;
          color: #ffffff;
          padding: 70px 20px;
          font-family: Arial, Helvetica, sans-serif;
        }

        .terms-container {
          max-width: 1000px;
          margin: 0 auto;
        }

        .terms-header {
          text-align: center;
          margin-bottom: 45px;
        }

        .terms-badge {
          display: inline-block;
          padding: 8px 15px;
          border-radius: 30px;
          border: 1px solid rgba(50, 191, 255, 0.3);
          background: rgba(50, 191, 255, 0.08);
          color: #32bfff;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 1px;
          margin-bottom: 18px;
        }

        .terms-header h1 {
          margin: 0 0 15px;
          font-size: clamp(38px, 6vw, 60px);
          letter-spacing: -2px;
        }

        .terms-header h1 span {
          color: #32bfff;
        }

        .terms-header p {
          margin: 0 auto;
          max-width: 700px;
          color: #9da7b3;
          line-height: 1.7;
          font-size: 15px;
        }

        .terms-updated {
          margin-top: 15px !important;
          font-size: 13px !important;
          color: #71808f !important;
        }

        .terms-content {
          background: rgba(17, 23, 30, 0.9);
          border: 1px solid #202a35;
          border-radius: 18px;
          padding: 40px;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
        }

        .terms-section {
          padding-bottom: 30px;
          margin-bottom: 30px;
          border-bottom: 1px solid #202a35;
        }

        .terms-section:last-child {
          margin-bottom: 0;
          padding-bottom: 0;
          border-bottom: none;
        }

        .terms-section h2 {
          margin: 0 0 14px;
          color: #ffffff;
          font-size: 22px;
        }

        .terms-section h2 span {
          color: #32bfff;
          margin-right: 8px;
        }

        .terms-section p {
          margin: 0 0 12px;
          color: #aab4bf;
          line-height: 1.8;
          font-size: 14px;
        }

        .terms-section p:last-child {
          margin-bottom: 0;
        }

        .terms-section ul {
          margin: 12px 0 0;
          padding-left: 22px;
          color: #aab4bf;
        }

        .terms-section li {
          margin-bottom: 9px;
          line-height: 1.7;
          font-size: 14px;
        }

        .terms-section li::marker {
          color: #32bfff;
        }

        .terms-highlight {
          margin-top: 15px;
          padding: 18px 20px;
          border-left: 3px solid #32bfff;
          border-radius: 8px;
          background: rgba(50, 191, 255, 0.06);
          color: #c6d0da;
          line-height: 1.7;
          font-size: 14px;
        }

        .terms-footer {
          text-align: center;
          margin-top: 30px;
          color: #667381;
          font-size: 13px;
          line-height: 1.6;
        }

        @media (max-width: 700px) {
          .terms-page {
            padding: 45px 15px;
          }

          .terms-content {
            padding: 25px 20px;
          }

          .terms-header h1 {
            letter-spacing: -1px;
          }

          .terms-section h2 {
            font-size: 20px;
          }
        }
      `}</style>

      <div className="terms-container">
        <header className="terms-header">
          <div className="terms-badge">VORTEX NETWORK</div>

          <h1>
            Terms of <span>Service</span>
          </h1>

          <p>
            Please read these Terms of Service carefully before using the
            Vortex Network website, services, downloads, and community
            platforms.
          </p>

          <p className="terms-updated">
            Last updated: {lastUpdated}
          </p>
        </header>

        <main className="terms-content">
          <section className="terms-section">
            <h2>
              <span>01.</span> Acceptance of Terms
            </h2>

            <p>
              By accessing or using Vortex Network, you agree to be bound by
              these Terms of Service. If you do not agree with these terms,
              please do not use our website, services, downloads, or community
              platforms.
            </p>

            <p>
              These terms apply to visitors, users, members, contributors,
              and anyone accessing or using services provided by Vortex
              Network.
            </p>
          </section>

          <section className="terms-section">
            <h2>
              <span>02.</span> Our Services
            </h2>

            <p>
              Vortex Network provides gaming-related services, software,
              Minecraft Bedrock addons, websites, digital content, community
              resources, and other projects.
            </p>

            <p>
              Features and services may be added, changed, suspended, or
              removed at any time. We may also release updates, patches, or
              new versions of our projects.
            </p>
          </section>

          <section className="terms-section">
            <h2>
              <span>03.</span> Accounts
            </h2>

            <p>
              Certain features may require you to create an account. You are
              responsible for keeping your account information secure and for
              activity that occurs through your account.
            </p>

            <ul>
              <li>Do not share your account credentials with others.</li>
              <li>Do not attempt to access another person's account.</li>
              <li>Provide accurate information where an account requires it.</li>
              <li>Notify us if you believe your account has been compromised.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>
              <span>04.</span> Minecraft Addons & Digital Content
            </h2>

            <p>
              Vortex Network may provide Minecraft Bedrock addons, scripts,
              configurations, resource packs, behaviour packs, documentation,
              and other digital content.
            </p>

            <p>
              You may use our publicly released addons for their intended
              purpose, subject to any additional license or usage terms
              provided with the individual project.
            </p>

            <ul>
              <li>
                Do not claim Vortex Network content as your own original work.
              </li>
              <li>
                Do not redistribute modified versions as official Vortex
                Network releases.
              </li>
              <li>
                Do not remove attribution or copyright notices where they are
                included.
              </li>
              <li>
                Do not use our content to impersonate Vortex Network or its
                developers.
              </li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>
              <span>05.</span> Website Usage
            </h2>

            <p>
              You agree to use the Vortex Network website responsibly and
              legally.
            </p>

            <ul>
              <li>Do not attempt to damage or disrupt the website.</li>
              <li>Do not attempt to bypass security measures.</li>
              <li>Do not abuse website forms, APIs, or other services.</li>
              <li>Do not upload malicious files or harmful content.</li>
              <li>Do not use automated systems to abuse or overload our services.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>
              <span>06.</span> Community Rules
            </h2>

            <p>
              If you participate in Vortex Network communities, including
              Discord or other community platforms, you are expected to treat
              other members respectfully.
            </p>

            <ul>
              <li>No harassment or targeted abuse.</li>
              <li>No spam or malicious advertising.</li>
              <li>No impersonation of staff or other community members.</li>
              <li>No malicious links, scams, or harmful downloads.</li>
              <li>Follow the rules of the specific community platform.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>
              <span>07.</span> Intellectual Property
            </h2>

            <p>
              Unless otherwise stated, Vortex Network and its licensors retain
              ownership of the original website content, branding, graphics,
              code, addons, documentation, and other materials created by or
              for Vortex Network.
            </p>

            <p>
              Nothing in these Terms of Service grants you ownership of Vortex
              Network intellectual property.
            </p>
          </section>

          <section className="terms-section">
            <h2>
              <span>08.</span> Third-Party Services
            </h2>

            <p>
              Vortex Network may link to or use third-party services such as
              Discord, CurseForge, GitHub, game platforms, hosting providers,
              authentication providers, or other external services.
            </p>

            <p>
              Third-party services have their own terms and privacy policies.
              Vortex Network is not responsible for the policies, availability,
              or actions of third-party services.
            </p>
          </section>

          <section className="terms-section">
            <h2>
              <span>09.</span> Availability
            </h2>

            <p>
              We aim to keep our services available and reliable, but we do
              not guarantee that the website, downloads, addons, servers, or
              other services will always be available or error-free.
            </p>

            <p>
              Maintenance, updates, technical problems, hosting issues, or
              circumstances outside our control may temporarily affect
              availability.
            </p>
          </section>

          <section className="terms-section">
            <h2>
              <span>10.</span> Disclaimer
            </h2>

            <p>
              Vortex Network services and digital content are provided on an
              "as available" basis. We make reasonable efforts to maintain our
              projects, but we cannot guarantee that they will be completely
              free from bugs, interruptions, or compatibility issues.
            </p>

            <div className="terms-highlight">
              Always back up your Minecraft worlds and important data before
              installing or updating addons, scripts, or other modifications.
            </div>
          </section>

          <section className="terms-section">
            <h2>
              <span>11.</span> Termination
            </h2>

            <p>
              We reserve the right to restrict or terminate access to our
              services where a user violates these Terms of Service, abuses
              our systems, engages in harmful activity, or otherwise creates
              a significant risk to Vortex Network or its community.
            </p>
          </section>

          <section className="terms-section">
            <h2>
              <span>12.</span> Changes to These Terms
            </h2>

            <p>
              We may update these Terms of Service from time to time. When
              changes are made, the updated version will be published on this
              page with a revised "Last updated" date.
            </p>

            <p>
              Continuing to use Vortex Network services after changes are
              published means you accept the updated terms.
            </p>
          </section>

          <section className="terms-section">
            <h2>
              <span>13.</span> Contact
            </h2>

            <p>
              If you have questions about these Terms of Service or need
              assistance with a Vortex Network service, please contact us
              through the official Vortex Network support channels.
            </p>
          </section>
        </main>

        <div className="terms-footer">
          © {new Date().getFullYear()} Vortex Network. All rights reserved.
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;

